import React from "react";
import { getBrand, getTheme } from "../utils/branding";
import { Shield, PhoneCall, Bug, Radar } from "lucide-react";

const MARKS = { aegis: Shield, sip: PhoneCall, bugscout: Bug };

export default function Logo({ size = "medium" }) {
  const brand = getBrand();
  const Mark = MARKS[getTheme()] || Radar;
  const sizes = {
    small: { f: 16, m: 26, i: 15, r: 8 },
    medium: { f: 20, m: 30, i: 18, r: 9 },
    large: { f: 28, m: 38, i: 22, r: 11 },
  };
  const s = sizes[size] || sizes.medium;

  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 10, fontFamily: "'Urbanist', sans-serif" }}>
      <span style={{
        width: s.m, height: s.m, borderRadius: s.r, display: "grid", placeItems: "center",
        background: brand.primary, color: brand.btnText, boxShadow: `0 0 18px ${brand.primary}55`, flex: "none"
      }}>
        <Mark size={s.i} strokeWidth={2.2} />
      </span>
      <span style={{ fontSize: s.f, fontWeight: 700, letterSpacing: 0.5, color: brand.textPrimary }}>
        {brand.name}
      </span>
    </span>
  );
}
